module.exports = __webpack_public_path__ + "static/media/5.ce7509ce.png";